module.exports = __webpack_public_path__ + "media/images/Web_Redeemed-47531534ef0edf291afaa15ef96cb730.png";